"use strict";

const informizelyFeedbackModule = (function () {
    let hasSeenInformizelyFeedbackTrigger = false;
    let observedInformizelyDialog = null;
    let observedInformizelyOverlay = null;
    let isClosingOrphanedInformizelyDialog = false;
    let isInitialized = false;

    const isInformizelyFeedbackUnavailable = () => {
        const feedbackTrigger = document.getElementById('open-feedback-form');

        if (feedbackTrigger) {
            hasSeenInformizelyFeedbackTrigger = true;
            return feedbackTrigger.style.display === 'none';
        }

        // Informizely may remove the trigger after the survey has been submitted.
        // Treat it as unavailable only after the trigger has existed on the page.
        return hasSeenInformizelyFeedbackTrigger;
    };

    const updateFeedbackButtonVisibility = () => {
        const feedbackIsUnavailable = isInformizelyFeedbackUnavailable();
        const feedbackButton = document.querySelector('[data-action="trigger-package-feedback"]');

        if (feedbackButton) {
            feedbackButton.hidden = feedbackIsUnavailable;
        }
    };

    const getInformizelyCloseButton = (dialog) => {
        return Array.from(dialog.getElementsByTagName('*')).find(element =>
            element.getAttribute('role') === 'button' &&
            element.getAttribute('aria-label') === 'close'
        );
    };

    const checkInformizelyDialog = () => {
        const dialog = document.getElementById('iz-cr');

        if (!dialog) {
            observedInformizelyDialog = null;
            observedInformizelyOverlay = null;
            isClosingOrphanedInformizelyDialog = false;
            return;
        }

        if (observedInformizelyDialog !== dialog) {
            observedInformizelyDialog = dialog;
            observedInformizelyOverlay = dialog.nextElementSibling;
            return;
        }

        if (!observedInformizelyOverlay) {
            observedInformizelyOverlay = dialog.nextElementSibling;
        }

        // Informizely should close the dialog when its overlay is removed. If the
        // dialog remains, use Informizely's own close control to finish closing it.
        if (!observedInformizelyOverlay || document.contains(observedInformizelyOverlay) || isClosingOrphanedInformizelyDialog) {
            return;
        }

        isClosingOrphanedInformizelyDialog = true;
        const closeButton = getInformizelyCloseButton(dialog);

        if (closeButton) {
            closeButton.click();
        }
    };

    const observeInformizelyFeedbackTrigger = () => {
        const feedbackTrigger = document.getElementById('open-feedback-form');
        if (!feedbackTrigger) {
            return;
        }

        const triggerAttributeObserver = new MutationObserver(updateFeedbackButtonVisibility);
        triggerAttributeObserver.observe(feedbackTrigger, {
            attributes: true,
            attributeFilter: ['style']
        });

        // Observe the page because Informizely may remove the trigger or its overlay after submission/close.
        const triggerRemovalObserver = new MutationObserver(() => {
            updateFeedbackButtonVisibility();
            checkInformizelyDialog();
        });
        triggerRemovalObserver.observe(document.body || feedbackTrigger.parentNode, {
            childList: true,
            subtree: true
        });

        updateFeedbackButtonVisibility();
        checkInformizelyDialog();
    };

    const triggerInformizelyFeedback = () => {
        if (isInformizelyFeedbackUnavailable()) {
            updateFeedbackButtonVisibility();
            return;
        }

        const feedbackTrigger = document.getElementById('open-feedback-form');

        if (!feedbackTrigger) {
            return;
        }

        feedbackTrigger.click();
    };

    const handleFeedbackButtonClick = (event) => {
        const feedbackButton = event.target.closest('[data-action="trigger-package-feedback"]');
        if (!feedbackButton) {
            return false;
        }

        event.preventDefault();

        triggerInformizelyFeedback();
        return true;
    };

    const init = () => {
        if (isInitialized) {
            return;
        }

        isInitialized = true;
        observeInformizelyFeedbackTrigger();
    };

    return {
        handleFeedbackButtonClick,
        init,
        updateFeedbackButtonVisibility
    };
})();

export default informizelyFeedbackModule;
